import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutLoadboardUsersDatRest extends Layout {
    sourceLmeUserToken: DataSource;
    tableDatLoadboardRestUsers: Table;
}
